// extracted by mini-css-extract-plugin
export var flexwrapper = "richinternallink-module--flexwrapper--e1a24";
export var imagestyle = "richinternallink-module--imagestyle--45232";
export var richinternallinkwrapper = "richinternallink-module--richinternallinkwrapper--bcee1";
export var title = "richinternallink-module--title--8fc0e";